import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "repayment-type-tooltip-text" }


import Tooltip from "@/components/pel-loan-configuration/Tooltip.vue";
import Icon from "@/components/shared/Icon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'RepaymentTypeTooltip',
  props: {
  repayment: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Tooltip, {
    "screen-padding": 0,
    class: "tooltip-wrapper right-zero"
  }, {
    toggle: _withCtx(() => [
      _createVNode(Icon, {
        icon: "info",
        class: "toggle-icon"
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, _toDisplayString(__props.repayment.repaymentTypeDetails?.name || __props.repayment?.repaymentTypeName), 1),
        _createElementVNode("p", null, _toDisplayString(__props.repayment.repaymentTypeTooltipText), 1)
      ])
    ]),
    _: 1
  }))
}
}

})